module.exports =
`

# 隱私權政策

「MUZIK Air」是由「希幔科技股份有限公司（MUZIK CREATIVE DIGITAL LTD. ）」所經營及提供，以古典音樂結合科技與網路社群功能的線上收聽平台。

「希幔科技股份有限公司（MUZIK CREATIVE DIGITAL LTD. ）」與「謬斯客國際有限公司（MUZIK International Co., Ltd.）」、「有樂出版事業有限公司（MUZIK & Arts Publication Co., Ltd.）」共同經營MUZIK這個品牌（以下稱本集團）。為共同經營之需要，當您同意以下隱私權政策時，視同授權以上三間公司應用您所授權的個人資料。我們非常尊重會員的個人隱私，以下是我們的隱私權保護政策。閱讀此隱私權政策可以幫助你了解本集團如何蒐集、應用及保護您所提供的個人資訊。

- 適用範圍

    以下的隱私權保護政策，適用於您在使用MUZIK旗下各式服務時，所涉及的個人資料蒐集、運用與保護。其他凡與MUZIK相互連結之線上交易或社群網站，不論是由第三人獨立經營，或是與MUZIK聯名經營，當您在這些網站進行交易或使用服務時，關於個人資料的保護，適用各網站的隱私權保護政策，MUZIK不負任何連帶責任。

- 個人資料之蒐集

  * 網路註冊

    網路註冊加入MUZIK會員時，請正確填寫您的姓名、暱稱、電子郵件地址，其他建議填寫欄位如性別、職業、住址、電話、出生日期等，您可以視個人意願進行填寫。當您填寫並同意送出時，即代表同意本集團蒐集、處理及利用您的個人資料。

  * 線上交易

    當您在本集團所經營之購物網站購買產品或服務時，MUZIK會請您提供訂購人及收件人資料，包括姓名、住址、電話及電子信箱，當您填寫並同意送出時，即代表同意本集團蒐集、處理及利用您的個人資料。

  * 線上活動及網路調查

    當您參與線上活動(Campaign)或網路調查(Survey)時，因活動需求會請您提供姓名、身份證字號、電話、電子信箱、出生年月日及住址等個人資訊。若您替您的親友參加相關MUZIK所辦之線上活動及網路調查時，您應取得該親友之同意。當您填寫並同意送出後，MUZIK將推定您已獲得該親友之授權並同意本集團蒐集、處理及利用您所提供之資料。

  * 實體活動，填寫會員申請表

    參加由MUZIK舉辦之實體活動，填寫會員申請表時，請正確填寫您的姓名、電子郵件地址，其他建議填寫欄位如性別、職業、住址、電話、出生日期等，您可以視個人意願進行填寫資料。當您填寫完並繳交後，即代表同意本集團蒐集、處理及利用您的個人資料。

  * 其他個人資料

    除上述之外，MUZIK會保留您上網瀏覽或查詢時，伺服器自行產生的相關記錄，包括您使用連線設備的IP位址、使用時間、使用的瀏覽器、瀏覽及點選資料紀錄等。

    ※ 請注意，在MUZIK刊登廣告之廠商，或與MUZIK連結的網站，也可能蒐集您個人的資料。對於您主動提供的個人資訊，這些廣告廠商、或連結網站有其個別的隱私權保護政策，其資料處理措施不適用MUZIK隱私權保護政策，MUZIK不負任何連帶責任。

- 資料之運用

  * 會員主動提供之個人資料

    加入MUZIK會員，會員之個人資料包含，姓名、身份證字號、電話、e-mail及住址…等資訊，您同意本集團將之作為交易確認、帳務請款、送退換貨、行銷活動通知、抽獎活動依據、通知受訪者抽獎結果，及分析與經營本集團之用。

    傳送商業性資料或電子郵件給您時，MUZIK除了在該電子郵件上註明是由MUZIK發送以外，也會在該資料或電子郵件上提供您能隨時停止接收這些資料或電子郵件的方法、說明或功能連結。

    如您不願意收到 MUZIK為您提供的行銷通知或商業性資料，請自行變更您的會員偏好設定，或來信至客服信箱，我們將協助您取消該服務(service@muzik.com.tw)。

  * 非主動註冊所產生的資料
    當您在本集團旗下各網站註冊成為會員後，除其所輸入的資料以外，凡未經您主動填寫所產生的資料，例如使用者機器的IP位址、使用時間、使用的瀏覽器、瀏覽及點選紀錄等資料，MUZIK僅對全體使用者行為總和進行分析，並不會對個別使用者進行分析。

    ※ 請注意，當會員可能違反本網站服務條款或是損害本網站及本網站其他會員，或司法單位因公眾安全要求我們公開特定會員的個人資料時，為保護、調查及遏止詐欺、未經授權或非法的活動之目的，本網站將在合法的程序下揭露或讀取會員資料。

- 第三者共用個人資料之政策

  您同意以下狀況，MUZIK將會與第三者共用您的個人資料：

  一、以便出貨廠商、物流廠商及服務 / 商品提供廠商按您所訂購之服務或商品進行送退換貨。

  二、為了提供您其他服務或優惠權益（例如折價券或優惠兌換券），需要與提供該服務或優惠商品之第三者共用您的資料時，MUZIK會在各活動或行銷網頁上提供充分說明，並且在資料蒐集之前通知您，您可以自由選擇是否接受這項特定服務或優惠。


- 會員個人資料修改/刪除之政策

  * 網路會員資料修改

    當您在MUZIK旗下網站中註冊成為會員後，您可以隨時利用您的會員ID和密碼修改您所輸入的任何個人資料（如：姓名、電子郵件地址、電話…等。

  * 實體活動會員資料修改

      如您是參加實體活動填寫會員申請表者，有任何會員資料修改需求，請來信客服信箱，我們將協助您進行修改(service@muzik.com.tw)。

  * 會員個人資料查詢、刪除

    因MUZIK採非完全實名制會員註冊，基於安全考量，對於會員欲查詢或刪除會員資料時，MUZIK將要求會員提供可辨識之身分證明。若無法透過您提供的資料進行確認者，請填具本人簽名蓋章之聲明保證書，傳真至(02)8751-5939並將正本郵寄至MUZIK。查詢或請求MUZIK閱覽個人資料或製作複製本者，請檢附工本費新台幣200元。

- 我們如何保護您的個人資訊

  為尊重會員的隱私，在網路會員的部分我們使用So-Net線上金流服務的SSL安全機制保障用戶個人資料傳送的安全。請會員妥善保管會員的密碼與個人資料，並提醒會員使用完畢 MUZIK的相關網路服務後，務必登出或關閉瀏覽器視窗，以免會員的資料遭人盜用。您也能協助我們採取預防措施，以保護您的個人資料。例如：經常改變密碼、密碼使用字母和數字混合的組合，並使用建議之瀏覽器（Google Chrome、Firefox、Apple Safari）。

- MUZIK隱私權保護政策諮詢

  若您對本集團旗下產品或服務的隱私權有任何疑問，都歡迎寫信到MUZIK客服信箱（service@muzik.com.tw），我們將盡速竭誠為您解答，謝謝！。

  ※ 附註：本隱私權政策會不定時變更。我們不會在未經您同意的情況下，削減本隱私權政策賦予您的權利。我們會將《隱私權政策》的所有變更都張貼在此網頁上，如果是重大變更，我們將會提供更明確的通知。

`
